import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function TestEmail({ operatorDetails }) {
    const [to, setTo] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleSend = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const response = await fetch(`${API_URL}/api/test-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    operatorId: operatorDetails ? operatorDetails._id : null,
                    to,
                    subject,
                    body
                })
            });

            const data = await response.json();
            if (response.ok) {
                setMessage('Email sent successfully!');
                setTo('');
                setSubject('');
                setBody('');
            } else {
                setMessage(`Error: ${data.message}`);
            }
        } catch (err) {
            setMessage(`Error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 30, maxWidth: 600, margin: '0 auto', background: 'white', borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
            <h2 style={{ marginBottom: 20 }}>Send Test Email</h2>
            <form onSubmit={handleSend} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                <div>
                    <label style={{ display: 'block', marginBottom: 5, fontWeight: 500 }}>To Address:</label>
                    <input 
                        type="email" 
                        value={to} 
                        onChange={(e) => setTo(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ccc' }}
                    />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: 5, fontWeight: 500 }}>Subject:</label>
                    <input 
                        type="text" 
                        value={subject} 
                        onChange={(e) => setSubject(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ccc' }}
                    />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: 5, fontWeight: 500 }}>Body:</label>
                    <textarea 
                        value={body} 
                        onChange={(e) => setBody(e.target.value)} 
                        required 
                        rows={5}
                        style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ccc' }}
                    />
                </div>
                <button 
                    type="submit" 
                    disabled={loading}
                    style={{ padding: '12px', background: '#16539C', color: 'white', border: 'none', borderRadius: 8, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer' }}
                >
                    {loading ? 'Sending...' : 'Send Email'}
                </button>
            </form>
            {message && (
                <div style={{ marginTop: 20, padding: 15, borderRadius: 8, background: message.includes('Error') ? '#fee2e2' : '#d1fae5', color: message.includes('Error') ? '#b91c1c' : '#047857' }}>
                    {message}
                </div>
            )}
        </div>
    );
}
